import React from 'react'
import { Router, RouteComponentProps } from '@reach/router'
import Appbar from 'components/Appbar'
import NeighborhoodSearch from './Search'
import TableView from './TableView'
import useNeighborhoods from './hooks/useNeighborhoods'
import { ModalLayer, PageContent } from '@ui'
import { useAppData } from '@providers'

export default function NeighborhoodManagement({ navigate }: RouteComponentProps) {
  const neighborhoods = useNeighborhoods()
  const { product } = useAppData()
  const neighborhoodsEnabled = product.features.includes('neighborhood')

  if (!neighborhoodsEnabled)
    return (
      <div className="flex justify-center">
        Neighborhoods is a premium feature.
        <br />
        Contact our customer success team for upgrade options!
      </div>
    )

  return (
    <>
      {/* eslint-disable @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Router primary={false} navigate={navigate}>
        <ModalLayer path="*" />
      </Router>
      <Appbar title="Neighborhoods">
        <NeighborhoodSearch
          navigate={navigate}
          queryTable={(query) => {
            neighborhoods.applyQuery(query)
          }}
        />
      </Appbar>
      <PageContent>
        <TableView
          {...{
            neighborhoods,
            navigate,
          }}
        />
      </PageContent>
    </>
  )
}
